import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomHandler<{ahriSorting: string}>

export const DispatchSortingParameter: HandlerType = props =>{
    props.dispatch({
        type:"Custom/AHRISystemToolConfigData/ahriSorting",
        ahriSorting: props.parameter.ahriSorting
    })
}
export const chain = [DispatchSortingParameter];

const AHRISystemToolAhriSortHandler = createHandlerChainRunner(chain,"AHRIDataSort");
export default AHRISystemToolAhriSortHandler;